class ShopifySwiper {
  constructor(sectionId, slidesPerView, slidesPerViewResponsive, spaceBetween) {
    this.sectionId = sectionId;
    this.slidesPerView = slidesPerView;
    this.slidesPerViewResponsive = slidesPerViewResponsive;
    this.spaceBetween = spaceBetween || 20;

    document.addEventListener("DOMContentLoaded", () => {
      this.initSwiper();
    });
  }

  parseSlidesPerView(value) {
    return value === "auto" ? "auto" : value;
  }

  initSwiper() {
    new Swiper(`#shopify-section-${this.sectionId} .swiper`, {
      direction: "horizontal",
      breakpoints: {
        690: {
          slidesPerView: this.slidesPerViewResponsive,
          spaceBetween: this.spaceBetween,
        },
        968: {
          slidesPerView: this.parseSlidesPerView(this.slidesPerView),
          spaceBetween: this.spaceBetween,
        },
      },
      navigation: {
        nextEl: `#shopify-section-${this.sectionId} .swiper-button-next`,
        prevEl: `#shopify-section-${this.sectionId} .swiper-button-prev`,
      },
      scrollbar: {
        el: `#shopify-section-${this.sectionId} .swiper-scrollbar`,
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const buttons_menu_responsive = document.querySelectorAll(
    ".button-open-collapse"
  );
  buttons_menu_responsive.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", !isExpanded);
    });
  });

  const buttons_first_reset = document.querySelectorAll("li.first-option");
  buttons_first_reset.forEach((button) => {
    button.addEventListener("click", (event) => {
      button.parentElement
        .querySelectorAll(".button-open-collapse")
        .forEach((button) => {
          button.setAttribute("aria-expanded", false);
        });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const responsive_active = window.matchMedia("(max-width: 690px)");

  if (responsive_active.matches) {
    document.querySelectorAll(".navigation-promo.swiper").forEach((swiper) => {
      new Swiper(swiper, {
        direction: "horizontal",
        breakpoints: {
          690: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          968: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      });
    });
  }
});

// MONOGRAM LOGIC
class MonogramComponent extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.product = [];
    this.addedToCart = false;
    this.PREFIX_URL = "https://cdn.shopify.com/s/files/1/0556/8711/9018/files/";

    this.placeHolders = {
      "Your Initials": "First, Middle, Last",
      "Monogram Style": "Choose a style",
      Location: "Choose a location",
      Color: "Choose a color",
      preview: "Preview",
    };

    this.styles = {
      b: "Block",
      d: "Diamond",
      s: "Script",
    };

    this.colors = {
      black: "Black",
      burgandy: "Burgundy",
      charcoal: "Charcoal",
      darkbrown: "Dark Brown",
      green: "Green",
      lavender: "Lavender",
      lightgrey: "Light Grey",
      navy: "Navy",
      redd: "Red",
      royalblue: "Royal Blue",
      white: "White",
      yellow: "Yellow",
    };

    this.properties = {};

    this.error = {};
  }

  connectedCallback() {
    const productAttr = this.getAttribute("product");
    this.render();
    // this.checkStateSubmit

    try {
      this.product = JSON.parse(productAttr);
    } catch (error) {
      console.error("Error parsing product JSON:", error);
    }
  }

  checkStateSubmit() {
    const { type } = this.data.settings;
    const inputs = this.typeInputs.find((input) => input.type === type).inputs;

    if (Object.keys(this.errors).length === 0) {
      inputs.forEach((input, index) => {
        if (input.type == "preview") return;
        this.errors[index] = true;
      });
    }
  }

  selectsContainersHTML() {
    return `
      ${this.createInput("Your Initials", "text")}
      ${this.createSelect("Monogram Style", [
        { label: "Choose a style", value: "" },
        { label: "Block", value: "b" },
        { label: "Diamond", value: "d" },
        { label: "Script", value: "s" },
      ])}
      ${this.createSelect("Location", [
        { label: "Choose a location", value: "" },
        { label: "Cuff", value: "Cuff" },
        { label: "Pocket", value: "Pocket" },
      ])}
      ${this.createSelect("Color", [
        { label: "Choose a color", value: "" },
        { label: "Black", value: "black" },
        { label: "Burgundy", value: "burgandy" },
        { label: "Charcoal", value: "charcoal" },
        { label: "Dark Brown", value: "darkbrown" },
        { label: "Green", value: "green" },
        { label: "Lavender", value: "lavender" },
        { label: "Light Grey", value: "lightgrey" },
        { label: "Navy", value: "navy" },
        { label: "Red", value: "redd" },
        { label: "Royal Blue", value: "royalblue" },
        { label: "White", value: "white" },
        { label: "Yellow", value: "yellow" },
      ])}
    `;
  }

  render() {
    this.innerHTML = `
      <div class="monogram-contianer">
        <div class="monogram-component__container rte ">
          <div class="monogram-component__input">
            <input type="checkbox" name="addMonogram" id="addMonogram">
          </div>
          <div class="monogram-component__label">
            <label for="addMonogram">
              Monogram <span>$12.95</span>
            </label>
          </div>
        </div>

        <div class="monogram-component__content">
          <div class="monogram-component__form">
          <div id="inputsContainer" style="display: none;">
              <p>For orders with monogramming, expect an additional 1-2 days for delivery.</p>
              <div class="checkbox-component__notifications"></div>
              ${this.selectsContainersHTML()}
            </div>
            <div id="preview" style="display:none;" id="preview"></div>
          </div>
        </div>
      </div>
    `;

    this.checkbox = this.querySelector("#addMonogram");
    this.inputsContainer = this.querySelector("#inputsContainer");
    this.previewContainer = this.querySelector("#preview");

    this.attachEventListeners();
  }

  handleInput(event) {
    const input = event.target;
    input.value = input.value
      .toUpperCase()
      .replace(/[^A-Z]/g, "")
      .slice(0, 3);
    input.classList.toggle(
      "error",
      input.value.length === 0 || input.value.length < 2
    );
    this.error = input.value.length === 0 || input.value.length < 2;
  }

  setMonogramStatus() {
    this.active = this.checkbox.checked;
    this.toggleMonogramOptions();
    this.checkDisabledButtonsSubmit();
    if (!this.checkbox.checked) {
      this.clearInputsAndSelects();
      this.destroyNotification();
      this.properties = {};
    }
  }

  clearInputsAndSelects() {
    const inputs = this.querySelectorAll("input");
    const selects = this.querySelectorAll("select");

    inputs.forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });

    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
  }

  attachEventListeners() {
    this.checkbox.addEventListener("input", () => this.setMonogramStatus());

    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("keyup", (event) => {
        this.updatePreview();
        this.handleInput(event);
        this.checkedValidateInitials();
        this.checkDisabledButtonsSubmit();
      });

      input.addEventListener("input", (event) => {
        this.handleInput(event);
        this.checkDisabledButtonsSubmit();
      });
    });

    this.querySelectorAll("select").forEach((input) => {
      input.addEventListener("change", () => {
        this.updatePreview();
        this.checkDisabledButtonsSubmit();
      });
    });
  }

  checkDisabledButtonsSubmit() {
    const style = this.querySelector("select").value;
    const location = this.querySelectorAll("select")[1].value;
    const color = this.querySelectorAll("select")[2].value;

    const readyForAdd = !!style && !!location && !!color;

    toggleDisabledStickyAddToCart(
      (this.checkbox.checked && this.error) || (!readyForAdd && !this.error)
    );
    toggleDisabledBuyItNow(
      this.checkbox.checked
    );
  }

  actionSubmit() {
    const style = this.querySelector("select").value;
    const location = this.querySelectorAll("select")[1].value;
    const color = this.querySelectorAll("select")[2].value;

    const readyForAdd = !!style && !!location && !!color;

    const submitButton = document.querySelector(
      "buy-buttons.buy-buttons>button"
    );
    submitButton.disabled =
      (this.checkbox.checked && this.error) || (!readyForAdd && !this.error);
  }

  checkedValidateInitials() {
    const input = this.querySelector('input[type="text"]');

    this.error = true;

    if (input.value.length === 0) {
      this.error = input.value.length === 0 || input.value.length < 2;
      this.createNotification("Please enter your initials", "error");
    }

    if (input.value.length < 2) {
      this.error = input.value.length === 0 || input.value.length < 2;
      this.createNotification("Insert 2 letter minimum", "error");
    }

    if (input.value.length > 1) {
      this.error = false;
      this.destroyNotification();
    }
  }

  createInput(labelText, inputType) {
    return `
      <div class="monogram-input">
        <label>${labelText}</label>
        <input type="${inputType}" placeholder="${this.placeHolders[labelText]}">
      </div>
    `;
  }

  destroyNotification() {
    const selector = this.querySelector(".checkbox-component__notifications");
    if (!selector) return;
    selector.innerHTML = "";
  }

  createNotification(message, type) {
    const selector = this.querySelector(".checkbox-component__notifications");
    if (!selector) return;
    selector.innerHTML = "";

    const HTML = `
      <div class="notification ${type}">
        <p>${message}</p>
      </div>
    `;

    selector.innerHTML = HTML;
  }

  createSelect(labelText, options) {
    return `
    <div class="monogram-input">
        <label>
          ${labelText}
        </label>
        <select>
            ${options
              .map(
                (option) =>
                  `<option value="${option.value}">${option.label}</option>`
              )
              .join("")}
        </select>
    </div>
    `;
  }

  toggleMonogramOptions() {
    this.inputsContainer.style.display = this.checkbox.checked
      ? "flex"
      : "none";
    this.updatePreview();
  }
  generateUrlImages(initials, style, location, color) {


    let colorTranslation = {  
      black: "bl",
      burgandy: "bu",
      charcoal: "ch",
      darkbrown: "db",
      green: "gr",
      lavender: "lv",
      lightgrey: "lg",
      navy: "nv",
      redd: "rd",
      royalblue: "rb",
      white: "wh",
      yellow: "ye"
    }

    let newColor = colorTranslation[color]

    const ImagesArray = [];
    const arrayInitials = initials.split("");

    if ((style === "D" || style === "d") && arrayInitials.length === 3) {
      [arrayInitials[1], arrayInitials[2]] = [
        arrayInitials[2],
        arrayInitials[1],
      ];
    }

    arrayInitials.forEach((letter, index) => {
      const styleFormat =
        style === "D" || style === "d" ? `d${index + 1}` : style;
      ImagesArray.push(`mono_${styleFormat}_${newColor}_${letter}.png`);
    });

    return ImagesArray;
  }

  generatePreviews(initials, style, location, color) {
    //if (!initials || !style || !location || !color) return;

    const images = this.generateUrlImages(initials, style, location, color);

    const imagesHTML = `
    <div class="monogram-preview-control">
      <label for="monogram-preview">Preview</label>
      <div class="monogram-preview" id="monogram-preview">
        ${
          !initials || !style || !location || !color
            ? ""
            : images
                ?.map((image) => {
                  return `<img src="${this.PREFIX_URL}${image}" alt="Monogram preview">`;
                })
                .join("")
        }
      </div>
    </div>
    `;

    this.previewContainer.innerHTML = imagesHTML;
    this.previewContainer.classList.toggle(
      "light-background",
      color === "wh" || color === "ye"
    );
    this.renderInfo = true;
  }

  updateCurrentProduct = async ({ key, properties, qty }) => {
    const groupId = key

    return await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        properties: {
          ...properties,
          _group_id: groupId,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.addedToCart = true;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  updateAndAddMonogramToCart({ key, properties }) {
    const parent = this.closest(".product-info-reference");
    const quantity = parent.querySelector('input[name="quantity"]').value;
    const groupId = key

    const formData = {
      id: this.product.productId,
      quantity: quantity ?? 1,
      properties: {
        _group_id: groupId,
      },
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.addedToCart = true;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  addMonogramToCart(id) {
    const parent = this.closest(".product-info-reference");
    const quantity = parent.querySelector('input[name="quantity"]').value;
    const formData = {
      id: this.product.productId,
      quantity: quantity ?? 1,
      properties: {
        _group_id: id,
      },
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.addedToCart = true;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  updatePreview() {
    const preview = this.querySelector("#preview");
    preview.style.display = this.active ? "block" : "none";

    const initials = this.querySelector('input[type="text"]').value;
    const style = this.querySelector("select").value;
    const location = this.querySelectorAll("select")[1].value;
    const color = this.querySelectorAll("select")[2].value;

    const validateSelect = (select) => {
      if (select.value === "choose" || select.value === "") {
        select.classList.add("error");
        return false;
      } else {
        select.classList.remove("error");
        return true;
      }
    };

    const isValidStyle = validateSelect(this.querySelector("select"));
    const isValidLocation = validateSelect(this.querySelectorAll("select")[1]);
    const isValidColor = validateSelect(this.querySelectorAll("select")[2]);

    const atcIsActive = document.querySelector("buy-buttons").innerText.includes("Add")

    const isValidValues =
      isValidStyle && isValidLocation && isValidColor && initials.length > 1 && atcIsActive;



    this.updateButtonSubmit(isValidValues);

    this.properties = {
      ...this.properties,
      initials,
      style: FormatPropertyBackend(style),
      location: FormatPropertyBackend(location),
      color: FormatPropertyBackend(color),
    };

    this.generatePreviews(initials, style, location, color);
  }

  updateButtonSubmit(isValidValues = false) {
    const buttonSubmit = document.querySelector(
      "buy-buttons button[type=submit]"
    );
    buttonSubmit.disabled = this.active && !isValidValues;
  }

  getProperties() {
    return this.properties;
  }

  avaibleForAddToCart(itemId) {
    let properties = this.getProperties();

    properties = Object.fromEntries(
      Object.entries(properties).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    if (Object.keys(properties).length === 0) {
      return null;
    }

    this.active && this.addMonogramToCart(itemId);
    return this.addedToCart;
  }

  onError() {
    return this.onError;
  }
}

customElements.define("monogram-component", MonogramComponent);

// MODAL COMPONENT
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.close = this.close.bind(this);
  }

  connectedCallback() {
    this.title = this.getAttribute("title") || "Default Title";
    this.render();

    const id = this.getAttribute("id");

    if (!id) return console.error("Modal component must have an id attribute");

    document.addEventListener("DOMContentLoaded", () => {
      const buttonClose = document
        .querySelector(`#${id}`)
        .querySelector(".close-button");
      const overlay = document
        .querySelector(`#${id}`)
        .querySelector(".overlay");
      if (buttonClose) {
        buttonClose.addEventListener("click", this.close);
      }

      if (overlay) {
        overlay.addEventListener("click", this.close);
      }
    });
  }

  disconnectedCallback() {
    this.querySelector(".close-button").removeEventListener(
      "click",
      this.close
    );
  }

  open() {
    this.querySelector(".modal").style.display = "flex";
  }

  close() {
    this.querySelector(".modal").style.display = "none";
  }

  toggleState() {
    this.querySelector(".modal").style.display =
      this.querySelector(".modal").style.display === "flex" ? "none" : "flex";
  }

  render() {}
}

customElements.define("modal-component", ModalComponent);

document.addEventListener("DOMContentLoaded", () => {
  const buttonFit = document.querySelector("#button-modal-fit");
  const buttonSize = document.querySelector("#button-modal-size");
  const modalFit = document.querySelector("#modal-fit");
  const modalSize = document.querySelector("#modal-size");

  const modals = [
    {
      button: buttonFit,
      modal: modalFit,
    },
    {
      button: buttonSize,
      modal: modalSize,
    },
  ];

  modals.forEach(({ button, modal }) => {
    if (button && modal) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (typeof modal.toggleState === "function") {
          modal.toggleState();
        } else {
          console.error(
            `toggleState method not found on modal with id ${modal.id}`
          );
        }
      });
    }
  });
});

function agregarEventoScroll() {
  const yotpoStars = document.querySelector(
    ".yotpo-bottomline.pull-left.star-clickable"
  );
  const yotpoReviewsWidget = document.querySelector(
    '[data-yotpo-instance-id="421150"]'
  );

  if (yotpoStars && yotpoReviewsWidget) {
    yotpoStars.addEventListener("click", function () {
      const rect = yotpoReviewsWidget.getBoundingClientRect();
      const posY = rect.top + window.pageYOffset;

      window.scrollTo({
        top: posY,
        behavior: "smooth",
      });
    });
    clearInterval(intervalId);
  }
}

const intervalId = setInterval(agregarEventoScroll, 1000);

class CheckboxOptions extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const data = this.getAttribute("data");
    this.data = JSON.parse(data);
    this.slug = this.data.slug;

    this.errors = {};
    this.readyForAdd = false;

    // Not is necessary to use timestamp for AddMonogram
    this.timestamp = generateUniqueNumber();
    this.slug = `${this.slug}-${this.timestamp}`;

    this.render();
  }

  actionSubmit() {
    const buttonSubmit = this.closest(".product-info-reference").querySelector(
      "buy-buttons.buy-buttons>button"
    );

    buttonSubmit.disabled = this.checkbox.checked && this.hasErrors();
    toggleDisabledStickyAddToCart(this.checkbox.checked && this.hasErrors());
  }

  render() {
    const { label, description, product_complementary_price } =
      this.data.settings;
    const freePrice =
      product_complementary_price == "$0"
        ? "Free"
        : product_complementary_price;

    this.innerHTML = `
      <div class="checkbox-container" id="checkbox-container-${this.slug}">
        <div class="checkbox-component__container rte">
          <div class="checkbox-component__input">
            <input type="checkbox" name="addcheckbox-${
              this.slug
            }" id="addcheckbox-${this.slug}">
          </div>
          <div class="checkbox-component__label">
            <label for="addcheckbox-${this.slug}">${label} ${freePrice}</label>
          </div>
        </div>
        <div class="checkbox-component__content" style="display: none;">
          <div class="checkbox-component__form">
            <p>${
              description.split("###")[0]
            }<span style="color: #C41E3A"><strong>${
      description.split("###")[1] ? description.split("###")[1] : ""
    }</strong></span>${description.split("###")[2] ? description.split("###")[2] : ""}</p>
            <div id="inputsContainer-${this.slug}">
              ${this.optionsHTML()}
            </div>
          </div>
        </div>
      </div>
    `;

    this.checkbox = this.querySelector(`#addcheckbox-${this.slug}`);
    this.inputsContainer = this.querySelector(`.checkbox-component__content`);

    this.checkbox.addEventListener("input", () => {
      this.checkFirstState();
      this.toggleVisibility();
      this.clearInputsAndSelects();
      this.actionSubmit();
    });

    this.addOptionListeners();
  }

  checkFirstState() {
    const { options: OriginOptions } = this.data;

    if (!Object.entries(this.errors).length === 0) return;
    OriginOptions.forEach((option, index) => {
      this.errors[index] = true;
    });
  }

  addOptionListeners() {
    const { options: OriginOptions } = this.data;

    OriginOptions.forEach((option, index) => {
      const { label, type, validate } = option;
      const elementId = `option-${handleize(label)}-${index}`;
      const element = this.querySelector(`#${elementId}`);

      if (!element) return;
      const assignEventType = type === "select" ? "change" : "keyup";
      const currentTarget =
        element.querySelector("input") || element.querySelector("select");

      currentTarget.addEventListener(assignEventType, (e) =>
        this.handleChange({
          e,
          validate,
          type,
          index,
        })
      );

      if (type === "text") {
        currentTarget.addEventListener("change", (e) =>
          this.handleChange({
            e,
            validate,
            type,
            index,
          })
        );
      }
    });
  }

  handleChange({ e, validate, type, index }) {
    const { target } = e;

    type === "text" && this.validateText(target, validate, index);
    type === "select" && this.validateSelect(target, validate, index);

    this.actionSubmit();
  }

  hasErrors() {
    console.log(this.errors);
    return Object.values(this.errors).some((error) => error);
  }

  validateText(target, validate, index) {
    const value = target.value;
    const { required, min_length } = validate;

    let error = false;

    if (required && !value) {
      error = true;
    } else if (min_length && value.length < min_length) {
      error = true;
    } else if (value.length == 0) {
      error = true;
    }

    this.errors[index] = error;

    target.classList.toggle("error", this.errors[index]);
  }

  validateSelect(target, validate, index) {
    const value = target.value;
    const { required, default_option } = validate;

    let error = false;

    if (
      required &&
      (!value || value === default_option || value === "undefined")
    ) {
      error = true;
    }

    this.errors[index] = error;

    target.classList.toggle("error", this.errors[index]);
  }

  clearInputsAndSelects() {
    const inputs = this.querySelector(
      ".checkbox-component__content"
    ).querySelectorAll("input");
    const selects = this.querySelector(
      ".checkbox-component__content"
    ).querySelectorAll("select");

    inputs.forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });

    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
  }

  toggleVisibility() {
    this.inputsContainer.style.display = this.checkbox.checked
      ? "flex"
      : "none";
  }

  createInput(labelText, inputType, placeholder, index) {
    const elementId = `option-${handleize(labelText)}-${index}`;
    return `
      <div class="checkbox-input" id="${elementId}">
        <label>${labelText}</label>
        <input type="${inputType}" placeholder="${placeholder}" oninput="this.value = this.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);">
      </div>
    `;
  }

  createSelect(labelText, options, index) {
    const elementId = `option-${handleize(labelText)}-${index}`;
    return `
    <div class="checkbox-input" id="${elementId}">
        <label>
          ${labelText}
        </label>
        <select>
            ${options
              .map(
                (option) =>
                  `<option value="${option.value}">${option.label}</option>`
              )
              .join("")}
        </select>
    </div>
    `;
  }

  optionsHTML() {
    const { options: OriginOptions } = this.data;

    return `
      ${OriginOptions.map((option, index) => {
        const { label, type, placeholder, options } = option;

        return `
            ${
              type === "select"
                ? this.createSelect(label, options, index)
                : this.createInput(label, "text", placeholder, index)
            }
          `;
      }).join("")}
    `;
  }

  getProperties() {
    const inputs = this.querySelectorAll('input[type="text"], select');
    const properties = {};

    inputs.forEach((input) => {
      if (input.tagName.toLowerCase() === "select") {
        properties[input.previousElementSibling.textContent.trim()] =
          input.value;
      } else {
        properties[input.previousElementSibling.textContent.trim()] =
          input.value;
      }
    });

    return properties;
  }

  updateCurrentProduct = async ({ key, properties, qty }) => {
    const groupId = key

    return await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        properties: {
          ...properties,
          _group_id: groupId,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.addedToCart = true;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  addProductReference({ key, quantity }) {
    if (!this.checkbox.checked || !this.data.settings.product_complementary)
      return;

    const groupId = key

    addToCart({
      productId: this.data.settings.product_complementary,
      properties: {
        _group_id: groupId,
      },
      quantity,
    });
  }
}

customElements.define("checkbox-options", CheckboxOptions);

class BreadcrumbsCollection {
  constructor(menuSelector, breadcrumbSelector) {
    this.menuSelector = menuSelector;
    this.breadcrumbSelector = breadcrumbSelector;
  }

  updateBreadcrumbs(searchText) {
    const menuItems = document.querySelectorAll(
      `.mega-menu .subnivel-child span`
    );
    let found = false;

    menuItems.forEach((span) => {
      if (found) return;

      const spanText = span.textContent.trim();
      if (spanText === searchText && !spanText.toLowerCase().includes("all")) {
        const linkElement = span.closest(".next-level")?.querySelector("a.h5");
        if (linkElement) {
          const breadcrumbItem = document.querySelector(
            this.breadcrumbSelector
          );
          const breadcrumbLink = breadcrumbItem.querySelector("a");

          breadcrumbLink.href = linkElement.href;
          breadcrumbLink.textContent = linkElement.textContent.trim();
          breadcrumbItem.style.display = "flex";

          found = true;
        }
      }
    });
  }
}

// class BreadcrumbsCollection {
//   constructor(menuSelector, breadcrumbSelector) {
//     this.menuSelector = menuSelector;
//     this.breadcrumbSelector = breadcrumbSelector;
//   }

//   updateBreadcrumbs(searchText, currentCategory, currentUrl) {
//     const breadcrumbList = document.querySelector(this.breadcrumbSelector);
//     breadcrumbList.innerHTML = '';

//     this.addBreadcrumb(breadcrumbList, '/', 'Home');

//     const topLevelCategory = this.getTopLevelCategory();

//     console.log(topLevelCategory);

//     if (topLevelCategory && topLevelCategory.url !== '#' && topLevelCategory.url !== currentUrl) {
//       this.addBreadcrumb(breadcrumbList, topLevelCategory.url, topLevelCategory.text);
//     }

//     if (currentUrl !== topLevelCategory.url) {
//       this.addBreadcrumb(breadcrumbList, currentUrl, currentCategory);
//     }

//     // this.updateSearchBreadcrumbs(searchText);
//   }

//   getTopLevelCategory() {
//     const menuItems = document.querySelectorAll(`${this.menuSelector} .subnivel-child span`);
//     let topLevelLink = {};
//     let found = false;

//     menuItems.forEach(span => {
//       if (found) return;

//       const spanText = span.textContent.trim();
//       if (spanText === searchText && !spanText.toLowerCase().includes('all')) {
//         const linkElement = span.closest('.next-level')?.querySelector('a.h5');
//         if (linkElement) {
//           topLevelLink = {
//             url: linkElement.href,
//             text: linkElement.textContent.trim()
//           };
//           found = true;
//         }
//       }
//     });

//     return topLevelLink;
//   }

//   addBreadcrumb(breadcrumbList, url, text) {
//     const listItem = document.createElement('li');
//     const link = document.createElement('a');
//     link.href = url;
//     link.textContent = text;
//     listItem.appendChild(link);
//     breadcrumbList.appendChild(listItem);
//   }

//   updateSearchBreadcrumbs(searchText) {
//     const breadcrumbItem = document.querySelector(this.breadcrumbSelector);
//     const menuItems = document.querySelectorAll(`.mega-menu .subnivel-child span`);
//     let found = false;

//     menuItems.forEach(span => {
//       if (found) return;

//       const spanText = span.textContent.trim();
//       if (spanText === searchText && !spanText.toLowerCase().includes('all')) {
//         const linkElement = span.closest('.next-level')?.querySelector('a.h5');
//         if (linkElement) {

//           const breadcrumbLink = breadcrumbItem.querySelector('a');

//           breadcrumbLink.href = linkElement.href;
//           breadcrumbLink.textContent = linkElement.textContent.trim();
//           breadcrumbItem.style.display = 'flex';

//           found = true;
//         }
//       }
//     });
//   }
// }

class FitGuideTabs {
  constructor() {
    this.PRIMARY_TABS = document.querySelectorAll(".header-buttons .btn");
    this.SECONDARY_TABS = document.querySelectorAll(
      ".group-content-buttons .btn"
    );

    this.CHILD_TABS = document.querySelectorAll(
      ".group-single-tabs-links .btn"
    );

    this.assignEvents();
  }

  assignEvents() {
    this.PRIMARY_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handlePrimaryTabClick(e));
    });

    this.SECONDARY_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleSecOndaryTabClick(e));
    });

    this.CHILD_TABS.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleChildTabClick(e));
    });
  }

  activateFirstTab(index, tab) {
    const parent = tab.parentElement.parentElement.querySelector(
      `.tabs-content-single[index="${index}"]`
    );

    const allSecondaryTabs = parent.querySelectorAll(
      ".group-content-buttons .btn"
    );
    const allSecondaryTabContents = parent.querySelectorAll(
      ".group-content-info .single-content"
    );

    allSecondaryTabs.forEach((tab) => tab.classList.remove("active"));
    allSecondaryTabContents.forEach((content) =>
      content.classList.remove("active")
    );

    if (allSecondaryTabs.length > 0) {
      allSecondaryTabs[0].classList.add("active");
    }
    if (allSecondaryTabContents.length > 0) {
      allSecondaryTabContents[0].classList.add("active");
    }

    const allChildTabs = parent.querySelectorAll(
      ".group-single-tabs-links .btn"
    );
    const allChildTabContents = parent.querySelectorAll(".single-tab-content");

    allChildTabs.forEach((tab) => tab.classList.remove("active"));
    allChildTabContents.forEach((content) =>
      content.classList.remove("active")
    );

    if (allChildTabs.length > 0) {
      allChildTabs[0].classList.add("active");
    }
    if (allChildTabContents.length > 0) {
      allChildTabContents[0].classList.add("active");
    }
  }

  handlePrimaryTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("index");
    const tabsContent = document.querySelectorAll(".tabs-content-single");
    const tabContent = document.querySelector(
      `.tabs-content-single[index="${tabId}"]`
    );

    tabsContent.forEach((tab) => tab.classList.remove("active"));
    this.PRIMARY_TABS.forEach((tab) => tab.classList.remove("active"));

    tab.classList.add("active");
    tabContent.classList.add("active");

    this.activateFirstTab(tabId, tab);
  }

  handleSecOndaryTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("index");
    const parent = tab.parentElement.parentElement;
    const tabsContent = parent.querySelectorAll(
      ".group-content-info .single-content"
    );
    const tabContent = parent.querySelector(
      `.group-content-info .single-content[index="${tabId}"]`
    );

    this.SECONDARY_TABS.forEach((tab) => tab.classList.remove("active"));
    tabsContent.forEach((tab) => tab.classList.remove("active"));
    tab.classList.add("active");
    tabContent.classList.add("active");

    const parentTab = tab.parentElement.parentElement.parentElement;
    const tabsContentChild = parentTab.querySelectorAll(
      `.single-content[index="${tabId}"] .single-tab-content`
    );
    tabsContentChild.forEach((tab) => tab.classList.remove("active"));
    tabsContentChild[0].classList.add("active");

    // Ensure first child tab is activated
    const childTabs = parentTab.querySelectorAll(
      `.single-content[index="${tabId}"] .group-single-tabs-links .btn`
    );
    childTabs.forEach((tab) => tab.classList.remove("active"));
    if (childTabs.length > 0) {
      childTabs[0].classList.add("active");
    }
  }

  handleChildTabClick(event) {
    const tab = event.target;
    const tabId = tab.getAttribute("subindex");

    const parent = tab.parentElement.parentElement;
    const tabsContent = parent.querySelectorAll(`.single-tab-content`);
    const tabContent = parent.querySelector(
      `.single-tab-content[subindex="${tabId}"]`
    );

    this.CHILD_TABS.forEach((tab) => tab.classList.remove("active"));
    tabsContent.forEach((tab) => tab.classList.remove("active"));

    tabContent.classList.add("active");
    tab.classList.add("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new FitGuideTabs();
});

//
class ProductOptions {
  constructor() {
    const optionsColor = document.querySelector("#optionsJson").textContent;
    const optionsProduct = document.querySelector(
      "#optionsJsonProduct"
    ).textContent;

    this.options = JSON.parse(optionsColor);
    this.productSettings = JSON.parse(optionsProduct);

    this.activeSettingColor =
      this.options[0].value == "Undefined" && this.options[0].image == "";

    this.dinamicSelects = {
      formId: document.querySelector('input[name="id"]'),
      currentColor: document.querySelector("#currentColor"),
      image: document.querySelector(
        ".product-gallery__media.snap-center.is-selected"
      ),
      price: document.querySelector(".product-price"),
      buttonSubmit: document.querySelector("buy-buttons.buy-buttons>button"),
      select: document.querySelector(".variant-picker__content-dropdown"),
      checkboxes: document.querySelectorAll(
        ".variant-picker__option-values[data-option-selector]"
      ),
      variantValue: document.querySelector("variant-option-value"),
    };

    this.currentVariant = {};

    this.selects = document.querySelectorAll(".color-swatch-option input");

    this.selects.forEach((select) => {
      select.addEventListener("change", (e) => this.colorChange(e));
    });

    this.assignOrFindVariant();
  }

  assignOrFindVariant() {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("variant_id");

    const variant = this.options.find((option) =>
      option.product[0].variants.find((variant) => variant.id == variantId)
    );

    this.assignVariant(variant);
  }

  assignVariant(variant) {
    const formatOrSetVariant = variant ?? this.options[0];
    const { product, productWithOption, value } = formatOrSetVariant;

    this.currentVariant = { name: value, variant };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });

    this.handleVariantChange({
      maxOptions: productWithOption.length,
      value,
    });
  }

  selectedOption(targetValue) {
    return this.options.find((option) => option.value == targetValue);
  }

  colorChange(e) {
    e.preventDefault();
    const value = e.target.value;
    const { product, productWithOption } = this.selectedOption(value);

    this.currentVariant = { ...this.currentVariant, name: value };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });
  }

  handleSelectChange(e) {
    e.preventDefault();
    const value = e.target.value;
    const { product, productWithOption } = this.selectedOption(value);

    this.currentVariant = { ...this.currentVariant, name: value };
    this.useChangeDataProduct({
      product: product[0],
      value,
      productWithOption,
    });
  }

  assignEventToSelects(value, productWithOption) {
    document
      .querySelectorAll(".variant-picker__content-dropdown")
      .forEach((parent) => {
        const select = parent.querySelector("select");
        if (!select) return;

        const newSelect = select.cloneNode(true);
        parent.replaceChild(newSelect, select);

        newSelect.addEventListener("change", () =>
          this.handleVariantChange({
            maxOptions: productWithOption.length,
            value,
          })
        );
      });
  }

  updateLegends(options, enableFirstOptionColor = false) {
    options?.forEach((option, index) => {
      const _index = enableFirstOptionColor ? index + 1 : index;
      const container = document.querySelector(`div[option="${_index}"]`);
      if (!container) return;

      container.querySelector("variant-option-value").innerHTML = `${option}`;
    });
  }

  useChangeDataProduct({ product, value, productWithOption }) {
    const { currentColor, image, formId } = this.dinamicSelects;
    currentColor.textContent = value;
    image.innerHTML = `<img src="${product.featured_image}" loading="lazy" width="100%" alt="Product image">`;

    productWithOption?.forEach((option) => {
      if (option.name === "Color" && !this.activeSettingColor) return;

      if (option.name === "Color" && value === "Undefined") {
        const container = document.querySelector(
          `.variant-picker__label-content--color .color-swatch-options`
        );
        container.innerHTML = this.generateOptionHtml("radio", option);
        container.querySelectorAll("label").forEach((label) => {
          label.addEventListener("change", (e) => this.colorChange(e));
        });
      } else {
        const typeSelects = {
          Fit: "checkbox",
        };
        const type = typeSelects[option.name] || "select";
        const container = document.querySelector(
          `.variant-picker__${option.name.toLowerCase().replace(" ", "-")}`
        );
        const content =
          type === "select"
            ? container.querySelector(`select`)
            : container.querySelector(`.variant-picker__option-values`);
        content.innerHTML = this.generateOptionHtml(type, option);

        if (type !== "select") {
          content.querySelectorAll("label").forEach((label) => {
            label.addEventListener("change", () =>
              this.handleVariantChange({
                maxOptions: productWithOption.length,
                value,
              })
            );
          });
        }
      }
    });

    this.assignEventToSelects(value, productWithOption);

    formId.value = product.variants[0].id;
  }

  generateOptionHtml(type, option) {
    return option.values
      .map((value, index) => {
        return type === "select"
          ? `<option value="${value}">${value}</option>`
          : `<input type="radio" ${
              index === 0 ? "checked" : ""
            } id="option-value-template--${value}" name="option${
              option.position
            }" value="${value}"><label class="block-swatch" for="option-value-template--${value}" data-option-value="${value}"><span>${value}</span></label>`;
      })
      .join("");
  }

  arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((value, index) => value === arr2[index]);
  }

  handleVariantChange({ maxOptions = 3, value }) {
    let options = {};
    const existOptionColor = this.productSettings.options.some(
      (option) => option.name === "Color"
    );

    for (let i = 1; i <= maxOptions; i++) {
      const optionName = `option${i}`;
      const optionInputs = document.querySelectorAll(`[name="${optionName}"]`);

      if (optionInputs.length === 0) continue;

      const optionValue = Array.from(optionInputs).find(
        (input) =>
          (input.type === "radio" && input.checked) ||
          input.tagName === "SELECT" ||
          input.type !== "radio"
      )?.value;

      if (optionValue !== undefined) {
        options[optionName] = optionValue;
      }
    }

    const { name } = this.currentVariant;
    const selectedOption = this.selectedOption(name);

    if (!selectedOption) return;

    const optionColorActive = !this.activeSettingColor && existOptionColor;
    const firstOption = optionColorActive ? value : options.option1;
    const optionsArray = Object.values(options).filter(
      (option) => option !== firstOption
    );

    options = [firstOption, ...optionsArray];

    const variant = selectedOption.product[0].variants.find((variant) =>
      this.arraysEqual(variant.options, options)
    );

    if (!variant) return;

    this.currentVariant = { name, variant };
    this.dinamicSelects.formId.value = variant.id;

    if (!variant.available) {
      this.dinamicSelects.buttonSubmit.disabled = true;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Sold Out";
    } else {
      this.dinamicSelects.buttonSubmit.disabled = false;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Add to Bag";
    }

    this.generateBackOrder();

    this.updateLegends(options, !optionColorActive);

    this.updateVariantUrl(variant.id);
  }

  updateVariantUrl(variantId) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    params.set("variant_id", variantId);
    window.history.replaceState({}, "", url.toString());
  }

  generateBackOrder() {
    const { variant } = this.currentVariant;

    const { backorder } = variant.metafields;

    const existBackorder = document.querySelector(".backorder-container");
    if (existBackorder) existBackorder.remove();

    if (!backorder || backorder == "available" || variant.available) return;

    const container = document.querySelector(
      `.product-info__buy-buttons form input[name="id"]`
    );
    const htmlBackorder = document.createElement("div");
    htmlBackorder.classList.add("backorder-container");
    htmlBackorder.innerHTML = `
    <div>
      <span>This item is on Backorder, estimated shipping date ${backorder}</span>
      <input type="hidden" name="properties[__backorder]" value="This item is on Backorder, estimated shipment date ${backorder}">
    </div>`;

    container.insertAdjacentElement("afterend", htmlBackorder);

    this.dinamicSelects.buttonSubmit.disabled = false;
    this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
      "Available for Backorder";
  }
}

class SwatchesGrouped {
  constructor({ id, product, event, drawer_id, value }) {
    this.product = product;
    this.parent = event.target.closest(".product-card");
    this.cardContainer = this.parent.querySelector(`#${id}`);
    this.imageContainer = this.parent.querySelector(".product-card__figure");
    this.url = this.parent.querySelector(".product-card__figure a");
    this.titleUrl = this.parent.querySelector(".product-card__title a");

    const { title, featured_image, second_image, url, variant_id, price } =
      this.product;
    const formatUrl = `${url}?variant_id=${variant_id}`;

    this.updateImages(this.product);
    this.updateTitle(title);
    this.updatePrice(price);
    this.updateUrl(formatUrl);
    this.updateDrawerId(drawer_id);
    this.setCurrentSwatch(value);
  }

  setCurrentSwatch(value) {
    const swatches = this.parent.querySelectorAll(".color-swatch-option a");

    swatches.forEach((swatch) => {
      swatch.classList.remove("active");

      if (swatch.getAttribute("data-value") == value) {
        swatch.classList.add("active");
      }
    });

    swatches && swatches.classList.add("active");
  }

  assignEventToSwatchers() {
    const swatches = this.cardContainer.querySelectorAll(
      ".color-swatch-option a"
    );
    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleSwatchChange({
          value: e.target.getAttribute("reference"),
        });
      });
    });
  }

  updateImages(product) {
    const { title, featured_image, second_image } = product;
    const anchor = this.imageContainer.querySelector("a");
    if (featured_image || second_image) {
      const img = this.imageContainer.querySelectorAll("img");
      if (img) img.forEach((img) => img.remove());
    }

    if (featured_image && anchor) {
      anchor.innerHTML =
        anchor.innerHTML +
        `<img class="img product-card__image"  src="${featured_image}" loading="lazy" alt="${title}">`;
    }

    if (second_image && anchor) {
      anchor.innerHTML =
        anchor.innerHTML +
        `<img class="img product-card__image product-card__image--secondary" src="${second_image}" loading="lazy" alt="${title}">`;
    }
  }

  updateTitle(title) {
    const titleElement = this.parent.querySelector(".product-card__title a");
    titleElement.innerHTML = title;
  }

  updatePrice(price) {
    const priceElement = this.parent.querySelector("sale-price");
    priceElement.innerHTML = price;
  }

  updateUrl(url) {
    const urlElement = this.parent.querySelector(".product-card__figure a");
    const urlTitle = this.parent.querySelector(".product-card__title a");
    urlElement.href = url;
    urlTitle.href = url;
  }

  updateDrawerId(drawer_id) {
    const { handle } = this.product;
    const quickView = this.parent.querySelector(".quick-view");
    quickView.setAttribute("aria-controls", drawer_id);
    quickView.setAttribute("data-handle", handle);
  }

  handleSwatchChange({ value }) {
    const { product, drawer_id } = this.options.find(
      (option) => option.value == value
    );
    const { title, featured_image, second_image, url, variant_id, price } =
      product[0];
    const formatUrl = `${url}?variant_id=${variant_id}`;

    this.updateImages(product[0]);
    this.updateTitle(title);
    this.updatePrice(price);
    this.updateUrl(formatUrl);
    // this.updateDrawerId(drawer_id)
  }
}

class ModalAlterationCart {
  constructor(data) {
    this.data = data;

    this.errors = {};

    this.modal = document.querySelector("modal-alterations");
    this.drawerItem = document.querySelector(".cart-drawer-items");
    this.modalErrors = document.querySelector(".modal-alterations__errors");
    this.possibleAddMonogram = false;
    this.PREFIX_URL = "https://cdn.shopify.com/s/files/1/0556/8711/9018/files/";

    this.typeInputs = [
      {
        type: "monogram",
        inputs: [
          {
            id: "monogram-initials",
            label: "Your Initials",
            type: "text",
            placeholder: "First, middle, last",
            reference: "initials",
            validate: {
              required: true,
              min_length: 2,
            },
          },
          {
            id: "monogram-style",
            label: "Monogram Style",
            type: "select",
            options: [
              { label: "Choose a style", value: "" },
              { label: "Block", value: "b" },
              { label: "Diamond", value: "d" },
              { label: "Script", value: "s" },
            ],
            reference: "style",
            validate: {
              required: true,
            },
          },
          {
            id: "monogram-location",
            label: "Location",
            type: "select",
            options: [
              { label: "Choose a location", value: "" },
              { label: "Cuff", value: "Cuff" },
              { label: "Pocket", value: "Pocket" },
            ],
            reference: "location",
            validate: {
              required: true,
            },
          },
          {
            id: "monogram-color",
            label: "Color",
            type: "select",
            options: [
              { label: "Choose a color", value: "" },
              { label: "Black", value: "bl" },
              { label: "Burgundy", value: "bu" },
              { label: "Charcoal", value: "ch" },
              { label: "Dark Brown", value: "db" },
              { label: "Green", value: "gr" },
              { label: "Lavender", value: "lv" },
              { label: "Light Grey", value: "lg" },
              { label: "Navy", value: "nv" },
              { label: "Red", value: "rd" },
              { label: "Royal Blue", value: "rb" },
              { label: "White", value: "wh" },
              { label: "Yellow", value: "ye" },
            ],
            reference: "color",
            validate: {
              required: true,
            },
          },
          {
            label: "Preview",
            type: "preview",
          },
        ],
      },
      {
        id: "alteration",
        type: "alteration",
        inputs: [
          {
            label: "Select Inseam",
            type: "select",
            options: [
              { label: "Select Inseam", value: "" },
              { label: "25”", value: "25”" },
              { label: "25.5”", value: "25.5”" },
              { label: "26”", value: "26”" },
              { label: "26.5”", value: "26.5”" },
              { label: "27”", value: "27”" },
              { label: "27.5”", value: "27.5”" },
              { label: "28”", value: "28”" },
              { label: "28.5”", value: "28.5”" },
              { label: "29”", value: "29”" },
              { label: "29.5”", value: "29.5”" },
              { label: "30”", value: "30”" },
              { label: "30.5”", value: "30.5”" },
              { label: "31”", value: "31”" },
              { label: "31.5”", value: "31.5”" },
              { label: "32”", value: "32”" },
              { label: "32.5”", value: "32.5”" },
              { label: "33”", value: "33”" },
              { label: "33.5”", value: "33.5”" },
              { label: "34”", value: "34”" },
              { label: "34.5” (Hem only)", value: "34.5” (Hem only)" },
              { label: "35” (Hem only)", value: "35” (Hem only)" },
              { label: "35.5” (Hem only)", value: "35.5” (Hem only)" },
            ],
            reference: "Select Inseam",
            validate: {
              required: true,
            },
          },
          {
            id: "alteration-type",
            label: "Alteration Type",
            type: "select",
            reference: "Alteration Type",
            options: [
              { label: "Choose Alterations", value: "" },
              { label: "Plain Hem", value: "Hem" },
              { label: "1.5” Cuff", value: "1.5” cuff" },
            ],
            validate: {
              required: true,
            },
          },
        ],
      },
      {
        id: "engraving",
        type: "engraving",
        inputs: [
          {
            label: "Your Initials",
            type: "text",
            placeholder: "First, Middle, Last",
            reference: "Your Initials",
            validate: {
              required: true,
              min_length: 2,
            },
          },
        ],
      },
    ];

    // set default but prevent submit form
    this.checkStateSubmit();
    this.validateUpdatedAddon();
    this.assignSubmitAction();
    this.validateMonogram();
  }

  validateUpdatedAddon() {
    const { type, typeAction } = this.data.settings;
    if (typeAction !== "edit") return null;

    const inputs = this.typeInputs.find((input) => input.type === type).inputs;
    inputs.forEach((input, index) => {
      const { label, type, validate } = input;
      const inputId = `modal-option-${handleize(label)}-${index}`;
      const inputElement = this.modal.querySelector(`#${inputId}`);

      if (!inputElement) return;

      type === "text" &&
        this.validateText(inputElement.querySelector("input"), validate, index);
      type === "select" &&
        this.validateSelect(
          inputElement.querySelector("select"),
          validate,
          index
        );

      this.checkStateSubmit();
    });
  }

  hasErrors() {
    const errorValues = Object.values(this.errors);
    return errorValues.some((error) => error === true);
  }

  setStateError() {
    const findInputs = this.typeInputs.find(
      (input) => input.type === this.data.settings.type
    ).inputs;
    const matchingInputs = findInputs.filter(
      (input) => input.type === "text" || input.type === "select"
    );

    const countInputs = matchingInputs.length;
    const resultArray = Array.from({ length: countInputs }, () => true);
    this.errors = resultArray;
  }

  addOptionListeners() {
    const { type } = this.data.settings;
    const inputs = this.typeInputs.find((input) => input.type === type).inputs;

    inputs.forEach((input, index) => {
      const { label, type, validate } = input;
      const inputId = `modal-option-${handleize(label)}-${index}`;
      const inputElement = this.modal.querySelector(`#${inputId}`);

      if (!inputElement) return;

      const assignEventType = type === "select" ? "change" : "keyup";
      const currentTarget =
        inputElement.querySelector("input") ||
        inputElement.querySelector("select");

      currentTarget.addEventListener(assignEventType, (e) =>
        this.handleChange({
          e,
          validate,
          type,
          index,
        })
      );

      if (type === "text") {
        currentTarget.addEventListener("change", (e) =>
          this.handleChange({
            e,
            validate,
            type,
            index,
          })
        );
      }
    });
  }

  handleChange({ e, validate, type, index }) {
    const { target } = e;

    type === "text" && this.validateText(target, validate, index);
    type === "select" && this.validateSelect(target, validate, index);

    this.checkStateSubmit();
    this.validateUpdatedAddon();
    this.generateOrUpdatePreview();
    this.changeBGPreview();
  }

  checkStateSubmit() {
    const { type } = this.data.settings;
    const inputs = this.typeInputs.find((input) => input.type === type).inputs;

    if (Object.keys(this.errors).length === 0) {
      inputs.forEach((input, index) => {
        if (input.type == "preview") return;
        this.errors[index] = true;
      });
    }

    const buttonSubmit = this.modal.querySelector("#optionsUpdate");
    if (!buttonSubmit) return;
    buttonSubmit.disabled = this.hasErrors();
  }

  changeBGPreview() {
    const { color } = this.getProperties();

    if (!color) return;

    const previewContainer = this.modal.querySelector(".images-rendered");
    previewContainer.classList.toggle(
      "light-background",
      color === "wh" || color === "ye" || color == "W" || color == "Y"
    );
  }

  validateText(target, validate, index) {
    const value = target.value;
    const { required, min_length } = validate;

    this.errors[index] =
      (required && !value) ||
      (min_length && value.length < min_length) ||
      value.length == 0;

    this.modalErrors.innerHTML =
      min_length && value.length < min_length
        ? `<p class="error">Minimum ${min_length} characters</p>`
        : "";

    target.classList.toggle("error", this.errors[index]);
  }

  validateSelect(target, validate, index) {
    const value = target.value;
    const { required, default_option } = validate;

    this.errors[index] =
      required && (!value || value === default_option || value === "undefined");

    target.classList.toggle("error", this.errors[index]);
  }

  async validateMonogram() {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    const lineItem = cart.items.find(
      (item) => item.id === this.data.line_item.id
    );

    if (lineItem) {
      const properties = lineItem.properties;

      if (
        properties.hasOwnProperty("initials") &&
        properties.hasOwnProperty("location") &&
        properties.hasOwnProperty("color")
      ) {
        this.possibleAddMonogram = true;
        return;
      }

      if (properties.hasOwnProperty("Your Initials")) {
        this.possibleAddMonogram = false;
        return;
      }

      if (properties.hasOwnProperty("Alteration Type")) {
        this.possibleAddMonogram = false;
        return;
      }
    }
  }

  getProperties() {
    const inputsAndSelects = this.modal.querySelectorAll(
      'input[name^="option"], select[name^="option"]'
    );
    const values = {};

    inputsAndSelects.forEach((element) => {
      values[element.getAttribute("reference")] = FormatPropertyBackend(
        element.value
      );
    });

    return values;
  }

  assignSubmitAction() {
    const buttonSubmit = this.modal.querySelector("#optionsUpdate");

    if (!buttonSubmit) return;

    buttonSubmit.addEventListener("click", (e) => {
      e.preventDefault();
      this.updateLineItemProperties();
    });
  }

  async addProductComplementary({ groupId, productId }) {
    const formData = {
      id: productId,
      properties: {
        _group_id: groupId,
      },
      quantity: this.data.line_item.quantity ?? 1,
    };


    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const cart = await response.json();
      this.addedToCart = true;
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return cart;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async checkAddProductComplementary(groupId) {
    const {
      type,
      modify_properties_alteration,
      modify_properties_engraving,
      modify_properties_monogram,
    } = this.data.settings;

    const alterationProductId = window.location.hostname.includes("test")
      ? 44636189917374
      : 43337255846058;
    const engravingProductId = window.location.hostname.includes("test")
      ? 42022919340222
      : 43337257517226;
    const monogramProductId = window.location.hostname.includes("test")
      ? 42022919209150
      : 43337257451690;

    if (type == "monogram" && !modify_properties_monogram) {
      await this.addProductComplementary({
        groupId,
        productId: monogramProductId,
      });
    }

    if (type == "alteration" && !modify_properties_alteration) {
      await this.addProductComplementary({
        groupId,
        productId: alterationProductId,
      });
    }

    if (type == "engraving" && !modify_properties_engraving) {
      await this.addProductComplementary({
        groupId,
        productId: engravingProductId,
      });
    }
  }

  async updateLineItemProperties() {
    const {
      id: lineItemId,
      properties: dataProperties,
      key,
    } = this.data.line_item;

    const { type, typeAction: action } = this.data.settings;

    const isEdit = action === "edit";
    const isMonogram = type === "monogram";

    const groupId = isEdit
      ? dataProperties["_group_id"]
      : Date.now().toString(36) + Math.random().toString(36).substring(2)

    const properties = this.getProperties();

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key.toString(),
          quantity: this.data.line_item.quantity ?? 1,
          properties: {
            ...properties,
            _group_id: groupId,
          },
        }),
      });
      const cart = await response.json();
      this.updateCurrentData(cart);
      toggleFooterDrawer();

      await this.checkAddProductComplementary(groupId);

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      this.setStateError();
      this.back();
    } catch (error) {
      console.error("Error in updated line properties:", error);
    }
  }

  updateCurrentData(cart) {
    const item = cart?.items.find((item) => item.id === this.data.line_item.id);
    if (!item) return;

    this.data.line_item = item;
  }

  getTypeItem() {
    const {
      has_alteration,
      has_color,
      has_initials,
      has_inseam,
      has_location,
      has_style,
      has_your_initials,
    } = this.data.settings;

    if (has_color && has_initials && has_style && has_location)
      return "monogram";
    if (has_inseam && has_alteration) return "alteration";
    if (has_your_initials) return "engraving";
  }

  open() {
    this.drawerItem.classList.toggle("moving");
    this.modal.classList.toggle("hidden");
    this.modal.classList.add("active");

    const html = this.renderForm();
    this.modal.querySelector(".modal-content").innerHTML = html;

    hiddeFooterDrawer();

    this.addOptionListeners();
    this.generateOrUpdatePreview();
  }

  createInput(
    labelText,
    inputType,
    placeholder,
    valueSelected,
    optionValue,
    propertieReference
  ) {
    const elementId = `modal-option-${handleize(labelText)}-${optionValue}`;
    return `
      <div class="checkbox-input option-cart" id="${elementId}">
        <label>${labelText}</label>
        <input value="${valueSelected}" reference-key="modal__${optionValue}" type="${inputType}" placeholder="${placeholder}" name="option${optionValue}" reference="${propertieReference}" oninput="this.value = this.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);">
      </div>
    `;
  }

  createSelect(
    labelText,
    options,
    valueSelected,
    optionValue,
    propertieReference
  ) {
    const elementId = `modal-option-${handleize(labelText)}-${optionValue}`;
    return `
    <div class="checkbox-input option-cart" id="${elementId}">
        <label>
          ${labelText}
        </label>
        <select name="option${optionValue}" reference="${propertieReference}">
            ${options
              .map(
                (option) =>
                  `<option value="${option.value}" ${
                    valueSelected == option.value ||
                    valueSelected == option.label
                      ? "selected"
                      : ""
                  }>${option.label}</option>`
              )
              .join("")}
        </select>
    </div>
    `;
  }

  getHTMLForm(properties = {}) {
    const typeItem = this.getTypeItem();
    const { type } = this.data.settings;

    const inputs = this.typeInputs.find(
      (input) => input.type === type || input.type === typeItem
    );

    if (!inputs) {
      return "";
    }

    return inputs.inputs
      .map((input, index) => {
        const valueSelected = properties[input.reference] || "";
        const propertieReference = input.reference;
        const valueFormated = InvertFormatPropertyBackend(valueSelected);

        switch (input.type) {
          case "select":
            return this.createSelect(
              input.label,
              input.options,
              valueFormated,
              index,
              propertieReference
            );
          case "text":
            return this.createInput(
              input.label,
              input.type,
              input.placeholder,
              valueFormated,
              index,
              propertieReference
            );
          case "preview":
            return `<div class="preview">${input.label}<div class="images-rendered"></div></div>`;
          default:
            return "";
        }
      })
      .join("");
  }

  renderForm() {
    const properties = this.data.line_item.properties;
    const HTML = this.getHTMLForm(properties);

    return HTML;
  }

  back() {
    this.drawerItem.classList.remove("moving");
    this.modal.classList.add("hidden");

    toggleFooterDrawer();
  }

  generateOrUpdatePreview() {
    const { initials, style, location, color } =
      this.getProperties() || this.data.line_item.properties;

    if (!initials || !style || !location || !color) return;

    const previewContainer = this.modal.querySelector(".images-rendered");

    const images = this.generateUrlImages(initials, style, location, color);

    previewContainer.innerHTML = "";
    images.forEach((image) => {
      const img = document.createElement("img");
      img.src = `${this.PREFIX_URL}${image}`;
      previewContainer.appendChild(img);
    });
  }

  generateUrlImages(initials, style, location, color) {
    const ImagesArray = [];
    const arrayInitials = initials.split("");

    if (
      InvertFormatPropertyBackend(style) == "d" &&
      arrayInitials.length === 3
    ) {
      [arrayInitials[1], arrayInitials[2]] = [
        arrayInitials[2],
        arrayInitials[1],
      ];
    }

    arrayInitials.forEach((letter, index) => {
      const preFormatStyle = InvertFormatPropertyBackend(style);

      const styleFormat =
        preFormatStyle == "d"
          ? `${preFormatStyle}${index + 1}`
          : preFormatStyle;

      const colorFrontFormat = InvertFormatPropertyBackend(color);
      ImagesArray.push(`mono_${styleFormat}_${colorFrontFormat}_${letter}.png`);
    });

    return ImagesArray;
  }
}

const hiddeFooterDrawer = () => {
  const drawer = document.querySelector("cart-drawer");
  const selector = document.querySelector("cart-drawer .modal-footer-bottom");
  const selectorFreeShipping = document.querySelector("free-shipping-bar");
  if (!selector) return;
  selectorFreeShipping?.classList.add("hidden");
  selector.classList.add("hidden");
};

const toggleFooterDrawer = () => {
  const drawer = document.querySelector("cart-drawer");
  const selector = document.querySelector("cart-drawer .modal-footer-bottom");
  const selectorFreeShipping = document.querySelector("free-shipping-bar");
  if (!selector) return;

  selectorFreeShipping?.classList.toggle("hidden", drawer.getAttribute("open"));
  selector.classList.toggle("hidden", drawer.getAttribute("open"));
};

const resetModalDrawerCart = (event) => {
  const drawerItem = document.querySelector(".cart-drawer-items");
  const modal = document.querySelector("modal-alterations");

  drawerItem?.classList.remove("moving");
  modal?.classList.add("hidden");
  modal?.classList.remove("active");

  if (!modal) return;

  // reset state modal edit
  modal.querySelector(".modal-content").innerHTML = "";
  toggleFooterDrawer();
};

const openEditModalCart = (e, type) => {
  e.preventDefault();
  const target = e.target;
  const data = target.parentElement.querySelector("script");
  const dataJson = JSON.parse(data.innerHTML);

  const modal = new ModalAlterationCart({
    ...dataJson,
    settings: {
      ...dataJson.settings,
      typeAction: type,
    },
  });

  modal.open();
};

document.addEventListener("DOMContentLoaded", () => {
  const btnBackSelectors = ["#back-step-cart", ".back-to-bag-drawer"];
  const btnBack = btnBackSelectors.map((selector) =>
    document.querySelector(selector)
  );

  btnBack.forEach((btn) => {
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        resetModalDrawerCart();
      });
    }
  });
});

const addToCart = async ({ productId, quantity = 1, properties = {} }) => {
  const addUrl = "/cart/add.js";
  const cartUrl = `${Shopify.routes.root}cart.js`;
  const formData = {
    id: productId,
    quantity: Number(quantity),
    properties: {
      ...properties,
    },
  };

  try {
    const response = await fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) ltkCartUpdate();

    if (!response.ok) {
      throw new Error(`Error 201: ${response.statusText}`);
    }

    const responseJson = await response.json();
    const cartResponse = await fetch(cartUrl);
    const cartContent = await cartResponse.json();

    cartContent["sections"] = responseJson["sections"];

    document.documentElement.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items")
            ? responseJson["items"]
            : [responseJson],
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      })
    );
  } catch (error) {
    console.error(error);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".add_product_by_id");
  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const productId = button.getAttribute("product-id");
      !!productId && addToCart({ productId });
    });
  });
});

const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

class BackorderProduct {
  constructor(id) {
    this.variant_id = id;

    this.dinamicSelects = {
      buttonSubmit: document.querySelector("buy-buttons.buy-buttons>button"),
    };

    const variantsSelector = document.querySelector("#custom-json-product");
    if (!variantsSelector) return;

    const variants = variantsSelector?.textContent;
    this.variants = JSON.parse(variants);
    this.backorder = document.querySelector(".backorder-container");

    this.backorder ? this.removeBackorderHTML() : this.showOrDestroyBackorder();
  }

  removeBackorderHTML() {
    const existBackorder = document.querySelector(".backorder-container");
    if (existBackorder) existBackorder.remove();
  }

  showOrDestroyBackorder() {
    const variant = this.variants.variantsMefields.find(
      (variant) => variant.id == this.variant_id
    );
    if (!variant) return;

    const { backorder } = variant.metafields;

    if (backorder && backorder !== "available") {
      this.createBackorder(backorder, variant);
    }
  }

  createBackorder(backorder, variant) {
    const { available, inventory_quantity, inventory_policy, price } = variant;

    if (!available) return;

    const container = document.querySelector(
      `.product-info__buy-buttons form input[name="id"]`
    );
    const htmlBackorder = document.createElement("div");
    htmlBackorder.classList.add("backorder-container");
    htmlBackorder.innerHTML = `
    <div>
      <span>This item is on Backorder, estimated shipment date ${backorder}</span>
      <input type="hidden" name="properties[backorder]" value="This item is on Backorder, estimated shipping date ${backorder}">
    </div>`;

    container.insertAdjacentElement("afterend", htmlBackorder);

    if (inventory_policy == "deny" && inventory_quantity == 0) {
      this.dinamicSelects.buttonSubmit.disabled = true;
      this.dinamicSelects.buttonSubmit.querySelector("div").innerHTML =
        "Sold Out";
    } else if (inventory_policy == "continue") {
      this.dinamicSelects.buttonSubmit.disabled = false;
      this.dinamicSelects.buttonSubmit.querySelector(
        "div"
      ).innerHTML = `Available for Backorder`;
    }
  }
}

class LineQuantity {
  constructor() {
    this.lineItems = document.querySelectorAll("line-item-quantity");
    this.assignEvents();
  }

  assignEvents() {
    this.lineItems.forEach((lineItem) => {
      const buttons = lineItem.querySelectorAll("button");

      buttons.forEach((button) => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener("click", (e) => {
          this.handleLineItemChange(e);
          LTKGetCart();
        });
      });
    });
  }

  handleLineItemChange(e) {
    e.preventDefault();
    const target = e.target;

    const button = target.closest("button");
    const type = button.classList.contains("decrease")
      ? "decrease"
      : "increase";

    const input = button.parentElement.querySelector("input");

    const value = parseInt(input.value);
    const newValue = type === "decrease" ? value - 1 : value + 1;

    if (!newValue) return;
    input.value = newValue;

    const event = new Event("change", { bubbles: true });
    input.dispatchEvent(event);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const lineQuantity = new LineQuantity();
});

const handleLearnMoreClick = (button) => {
  const parentElement = button.closest(
    ".product-grouping__learn_more"
  ).parentNode;
  const colorSwatchOption = parentElement.querySelectorAll(
    ".color-swatch-option"
  );

  colorSwatchOption.forEach((option) => {
    option.classList.remove("hidden");
    option.classList.remove("hidden-sm");
  });

  button.closest(".product-grouping__learn_more").classList.add("hidden");
};

const FormatPropertyBackend = (property) => {
  const properties = {
    bl: "BL",
    bu: "BU",
    ch: "CH",
    db: "DB",
    gr: "G",
    lv: "LV",
    lg: "LG",
    nv: "N",
    rd: "R",
    rb: "RB",
    wh: "W",
    ye: "Y",
    b: "M1",
    d: "M2",
    s: "M3",
  };
  return properties[property] || property;
};

const InvertFormatPropertyBackend = (property) => {
  const properties = {
    bl: "BL",
    bu: "BU",
    ch: "CH",
    db: "DB",
    gr: "G",
    lv: "LV",
    lg: "LG",
    nv: "N",
    rd: "R",
    rb: "RB",
    wh: "W",
    ye: "Y",
    b: "M1",
    d: "M2",
    s: "M3",
  };

  const invertedProperties = {};
  for (const key in properties) {
    if (properties.hasOwnProperty(key)) {
      invertedProperties[properties[key]] = key;
    }
  }

  return invertedProperties[property] || property;
};

const submitCartDataListrak = (cart) => {
  const cartItems = cart.items;
  let cartLink = {};

  if (cartItems.length > 0) {
    cartItems.forEach((item, i) => {
      const sku = _ltk.Shopify.GetSkuProperty(item.id, item.sku);
      const { title, quantity, price, image, url: link } = item;
      _ltk.SCA.AddItemWithLinks(sku, quantity, price / 100, title, image, link);

      if (i <= 9) {
        cartLink[item.variant_id] = item.quantity;
      }
    });

    _ltk.SCA.Meta1 = cart.token;
    _ltk.SCA.CartLink = encodeURIComponent(
      JSON.stringify(cartLink).replace(/:/g, "-")
    ).replace(/,/g, "%2C");
    _ltk.SCA.Submit();
  } else {
    _ltk.SCA.ClearCart();
  }
};

const ltkCartUpdate = async () => {
  const url = `${window.location.origin}/cart.js`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const cart = await response.json();
    submitCartDataListrak(cart);
  } catch (error) {
    console.error("Error fetching cart data from listrak:", error);
  }
};

const getURLParameter = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const LTKProdBrowse = () => {
  const variants = meta.product.variants;
  setTimeout(() => {
    const idParam = getURLParameter("variant");
    const variant = idParam
      ? variants.find((variant) => variant.id == idParam)
      : variants[0];
    _ltk.Activity.AddProductBrowse(variant.sku);
  }, 1000);
};

const LTKGetCart = () => {
  return setTimeout(() => {
    _ltk.Shopify.GetCartData();
  }, 1000);
};

document.addEventListener("DOMContentLoaded", () => {
  // BROWSE ACTIVITY LISTRAK
  if (window.location.href.includes("/products/")) {
    LTKProdBrowse();
  }
});

const handleize = (text) => {
  text = text.toLowerCase();
  text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  text = text.replace(/[^a-z0-9]+/g, "-");
  text = text.replace(/^-+|-+$/g, "");
  return text;
};

class QuickViewDrawerSettings {
  constructor() {
    this.quickViewButtons = document.querySelectorAll(".quick-view");

    this.assignEvents();
  }

  assignEvents() {
    if (this.quickViewButtons.length == 0) return false;
    this.quickViewButtons.forEach((button) => {
      const quickViewDrawer =
        button.parentElement.querySelector("quick-view-drawer");
      button.addEventListener("click", async () => {
        const handle = button.getAttribute("data-handle");
        quickViewDrawer.setAttribute("handle", handle);

        await quickViewDrawer.show();
      });
    });
  }
}

class ProductSwatchSettings {
  constructor() {
    this.assignEvents();
  }

  assignEvents() {
    const swatches = document.querySelectorAll(".color-swatch-option a");

    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        const parent = swatch.closest("safe-sticky");
        if (parent) return;

        e.preventDefault();
        this.handleSwatchChange({
          handle: swatch.getAttribute("data-handle"),
          value: swatch.getAttribute("data-value"),
          event: e,
        });
      });
    });
  }

  async handleSwatchChange({ handle, value, event }) {
    if (!handle) return;

    const responseContent = await (
      await fetch(`${window.Shopify.routes.root}products/${handle}`)
    ).text();

    const optionsData = new DOMParser()
      .parseFromString(responseContent, "text/html")
      .getElementById("options-json-reference").innerHTML;

    const optionsByProduct = JSON.parse(optionsData);
    const currentOption = optionsByProduct.find(
      (option) => option.value == value
    );
    const product = currentOption.product[0];
    const drawer_id = currentOption.drawer_id;

    if (!currentOption) return;
    new SwatchesGrouped({
      id: `card-swatch-${product.id}`,
      product: product,
      event,
      drawer_id,
      value,
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new QuickViewDrawerSettings();
  new ProductSwatchSettings();
});

class assingEventModal {
  constructor(idModal) {
    if (!idModal) return;
    const section = document.getElementById(idModal);

    section.querySelector(".close-button").addEventListener("click", () => {
      section.close();
    });
  }
}

const getSectionByHandleProduct = async ({ handle, dataId }) => {
  if (!handle || !dataId) return;

  const responseContent = await (
    await fetch(`${window.Shopify.routes.root}products/${handle}`)
  ).text();

  const idReference = dataId == "modal-fit" ? "modal-size" : dataId;
  const idModal = dataId == "modal-fit" ? "modal-size-reference" : dataId;

  const sectionReference = new DOMParser()
    .parseFromString(responseContent, "text/html")
    .getElementById(idReference).innerHTML;

  const sectionToReplace = document.getElementById(idModal);

  sectionToReplace.innerHTML = sectionReference;
  sectionToReplace.open();
};

const renderModal = async (event) => {
  const handle = event.target.parentElement.getAttribute("data-handle");
  const dataId = event.target.parentElement.getAttribute("data-section");
  const idModal = dataId == "modal-fit" ? "modal-size-reference" : dataId;

  await getSectionByHandleProduct({
    handle,
    dataId,
  });

  new FitGuideTabs();
  new assingEventModal(idModal);
};

const generateUniqueNumber = (prev, length) => {
  const randomNumber = Math.floor(10000000 + Math.random() * 90000000)
    .toString()
    .slice(0, length);
  const formatPrev = prev ? prev : "";
  return `${formatPrev}${randomNumber}`;
};

const hiddenStickyAddToCart = (hidden) => {
  const stickyAddToCart = document.querySelector("product-quick-add");
  if (!stickyAddToCart) return;
  stickyAddToCart.classList.toggle("hidden", hidden);

  const parent = document.querySelector("product-quick-add");
  if (!parent) return;
  parent.classList.toggle("hidden", hidden);
};

const disableBuyItNowButton = (disabled) => {
  const buyItNowButton = document.querySelector(".button-bin");
  if (!buyItNowButton) return;

  disabled
    ? buyItNowButton.setAttribute("disabled", "disabled")
    : buyItNowButton.removeAttribute("disabled");
  disabled
    ? buyItNowButton.classList.add("disabled")
    : buyItNowButton.classList.remove("disabled");
  disabled
    ? buyItNowButton.classList.add("hidden")
    : buyItNowButton.classList.remove("hidden");

  buyItNowButton.addEventListener("click", function (event) {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};

const disabledStickyMain = (disabled) => {
  const stickyButtons = [
    ...document.querySelectorAll("product-quick-add button[type=submit]"),
  ];

  if (!stickyButtons) return;

  stickyButtons.forEach((button) => {
    button.disabled = disabled;
  });
};

const toggleDisabledStickyAddToCart = (disabled = false) => {
  disabledStickyMain(disabled);
  hiddenStickyAddToCart(disabled);
};

const toggleDisabledBuyItNow = (disabled = false) => {
  disableBuyItNowButton(disabled);
};

